import React from 'react'
import { Component } from 'reflux'
import { PurchaseOrderStore, PurchaseOrderStoreActions, STATUS } from '../../stores/purchaseOrderStore'
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Typography,
  Box,
  Divider,
  Dialog,
  DialogContent,
  Backdrop
} from '@material-ui/core'
import { toast } from 'react-toastify'
import VisibilityIcon from '@material-ui/icons/Visibility'
import IconButton from '@material-ui/core/IconButton'
import { OrderList } from '../order'

const ORDER_LINE_TYPES = [
  { type: 'ORDER', label: 'Order' },
  { type: 'STAFFPURCHASE', label: 'Staff Purchase' },
  { type: 'WAREHOUSE', label: 'To Warehouse' },
  { type: 'OTHER', label: 'Andet' }
]

export default class PurchaseOrderReceiveHandle extends Component {
  constructor(props) {
    super(props)
    this.stores = [PurchaseOrderStore]
    this.storeKeys = ['purchaseOrdersToReceiveDetails', 'status']
    this.state = {
      showOrderModal: false,
      selectedOrderID: null
    }
  }

  componentDidMount() {
    const purchaseOrderIDs = this.props.location.state?.purchaseOrderIDs
    if (purchaseOrderIDs && purchaseOrderIDs.length > 0) {
      PurchaseOrderStoreActions.fetchMultiplePurchaseOrders(purchaseOrderIDs)
    }
  }

  componentDidUpdate() {
    if (this.state.status === STATUS.FETCHING_ERROR) {
      toast.error('Kunne ikke hente indkøbsordrer', { autoClose: 7500 })
      PurchaseOrderStoreActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_ERROR) {
      toast.error('Kunne ikke slette indkøbsordre', { autoClose: 7500 })
      PurchaseOrderStoreActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_SUCCESS) {
      toast.success('Indkøbsordre slettet', { autoClose: 7500 })
      PurchaseOrderStoreActions.clearToast()
    }
  }

  getLinesByType(type) {
    const allLines = this.state.purchaseOrdersToReceiveDetails?.flatMap(po => po.purchaseOrderlines || []) || []
    if (type === 'OTHER') {
      return allLines.filter(l => !['ORDER', 'STAFFPURCHASE', 'WAREHOUSE'].includes(l.orderLineType))
    }
    return allLines.filter(l => l.orderLineType === type)
  }

  groupLinesByOrderID(lines) {
    const groups = {}
    lines.forEach(line => {
      const key = line.orderID || 'NOORDER'
      if (!groups[key]) groups[key] = []
      groups[key].push(line)
    })
    return groups
  }

  handleShowOrder = orderID => {
    this.setState({ showOrderModal: true, selectedOrderID: orderID })
  }

  handleCloseOrderModal = () => {
    this.setState({ showOrderModal: false, selectedOrderID: null })
  }

  renderTable(type, label) {
    const lines = this.getLinesByType(type)
    if (lines.length === 0) return null

    const groupedByOrder = this.groupLinesByOrderID(lines)

    return (
      <Paper
        elevation={3}
        style={{ marginBottom: 32, padding: 0, borderRadius: 10, overflow: 'hidden', border: '1px solid #e0e0e0', background: '#fafbfc' }}
      >
        <Box px={3} py={2} bgcolor='#f6f8fa' borderBottom='1px solid #e0e0e0'>
          <Typography variant='h6' style={{ fontWeight: 600 }}>
            {label}
          </Typography>
        </Box>
        <Table size='small' style={{ minWidth: 1200, width: '100%' }}>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: 120, fontWeight: 600, background: '#f6f8fa' }}>OrderID</TableCell>
              <TableCell style={{ width: 120, fontWeight: 600, background: '#f6f8fa' }}>Varenr.</TableCell>
              <TableCell style={{ width: 320, fontWeight: 600, background: '#f6f8fa' }}>Beskrivelse</TableCell>
              <TableCell style={{ width: 80, fontWeight: 600, background: '#f6f8fa', textAlign: 'right' }}>Antal</TableCell>
              <TableCell style={{ width: 120, fontWeight: 600, background: '#f6f8fa' }}>Status</TableCell>
              <TableCell style={{ width: 120, fontWeight: 600, background: '#f6f8fa' }}>Note</TableCell>
              <TableCell style={{ width: 80, fontWeight: 600, background: '#f6f8fa' }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(groupedByOrder).map(([orderID, orderLines]) => {
              const showNoOrderHeader = orderID === 'NOORDER' && type === 'ORDER'
              return (
                <React.Fragment key={orderID}>
                  <TableRow style={{ background: '#e3f2fd' }}>
                    <TableCell colSpan={6} style={{ fontWeight: 700 }}>
                      {orderID !== 'NOORDER' ? `OrderID: ${orderID}` : showNoOrderHeader ? 'Ingen OrderID' : ''}
                    </TableCell>
                    <TableCell>
                      {orderID !== 'NOORDER' && (
                        <IconButton color='primary' onClick={() => this.handleShowOrder(orderID)} aria-label='Vis ordre'>
                          <VisibilityIcon />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                  {orderLines.map(line => {
                    const isReceived = Number(line.amountReceived) === Number(line.amountOfProducts)
                    return (
                      <TableRow
                        key={line.purchaseOrderLineID}
                        hover
                        style={{
                          background: isReceived ? '#fff' : '#ffeaea'
                        }}
                      >
                        <TableCell>{line.orderID || ''}</TableCell>
                        <TableCell style={{ fontFamily: 'monospace' }}>{line.productVariationUID}</TableCell>
                        <TableCell>
                          <Typography variant='body2' style={{ whiteSpace: 'pre-line' }}>
                            {line.description}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textAlign: 'right' }}>{line.amountOfProducts}</TableCell>
                        <TableCell>
                          {isReceived ? (
                            <Typography variant='caption' style={{ color: '#388e3c' }}>
                              Modtaget
                            </Typography>
                          ) : (
                            <Typography variant='caption' style={{ color: '#d32f2f' }}>
                              Ikke modtaget
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell>
                          <Typography variant='body2' style={{ whiteSpace: 'pre-line' }}>
                            {line.purchaseOrderLineNote || ''}
                          </Typography>
                        </TableCell>
                        <TableCell />
                      </TableRow>
                    )
                  })}
                </React.Fragment>
              )
            })}
          </TableBody>
        </Table>
      </Paper>
    )
  }

  renderOrderModal() {
    const { showOrderModal, selectedOrderID } = this.state
    if (!showOrderModal || !selectedOrderID) return null
    return (
      <Dialog open={showOrderModal} onClose={this.handleCloseOrderModal} maxWidth='xl' fullWidth>
        <DialogContent>
          <OrderList filterOrderID={selectedOrderID} isPopUp={true} />
        </DialogContent>
      </Dialog>
    )
  }

  render() {
    const isLoading = this.state.status === STATUS.IS_FETCHING
    return (
      <Box p={3} width='100%' maxWidth='100vw' mx='auto' position='relative'>
        <Backdrop open={isLoading} style={{ zIndex: 1000, color: '#fff' }}>
          <CircularProgress color='inherit' />
        </Backdrop>
        <Typography variant='h5' gutterBottom style={{ fontWeight: 700, marginBottom: 24 }}>
          Modtag indkøbsordre
        </Typography>
        <Divider style={{ marginBottom: 32 }} />
        {ORDER_LINE_TYPES.map(t => this.renderTable(t.type, t.label))}
        {this.renderOrderModal()}
      </Box>
    )
  }
}
